import { Reveal } from "./Reveal";
import { AppStoreButton } from "./AppStoreButton";

export const DownloadCta = () => (
  <section id="download" data-testid="download-section" className="mx-auto max-w-7xl px-5 pb-28 sm:px-8 sm:pb-36">
    <Reveal>
      <div className="relative overflow-hidden rounded-[2.5rem] bg-espresso px-7 py-16 text-sand sm:px-14 sm:py-20">
        <div
          aria-hidden="true"
          className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[radial-gradient(circle_at_35%_35%,#F7C6B6_0%,#E07A5F_48%,#C86A52_100%)] opacity-80 blur-2xl"
        />
        <div
          aria-hidden="true"
          className="absolute -bottom-40 -left-24 h-80 w-80 rounded-full bg-sage/20 blur-3xl"
        />
        <div className="relative flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-6">
            <img
              src="/assets/app-icon-1024.png"
              alt="STETH app icon"
              data-testid="download-app-icon"
              className="hidden h-20 w-20 rounded-[1.4rem] shadow-[0_20px_40px_-15px_rgba(0,0,0,0.6)] sm:block"
            />
            <div>
              <h2 className="max-w-xl font-editorial text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">
                Find someone who gets the life{" "}
                <span className="font-normal italic text-peach">behind the credentials.</span>
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-sand/65">
                Free to download. Verified community. You must be 18 or older to
                create an account.
              </p>
            </div>
          </div>
          <AppStoreButton testid="app-store-download-btn-footer" dark={false} className="shrink-0" />
        </div>
      </div>
    </Reveal>
  </section>
);
